import { DataBean } from "../DataBean";
export  const ESTADO_COMITE=[
        {id:1,name:"REGISTRADO"},
        {id:3,name:"COMITE CREDITO"},
        {id:2,name:"APROBADO"},
        {id:4,name:"RECHAZADO"},
        {id:5,name:"APLAZADO"},
        {id:6,name:"FIRMANDO"},
    ];
export class PortfolioDeterioration extends DataBean {

    // public async getRequestCreditRender(page:number|null,rows:number|null,props:any): Promise<any> {
    //     return this.getCustomService("CreditCore", "com.advantage.shared.Report_getRequestCreditRender_Number_Number_java.util.Map", 
    //         [page,rows,props]);
    // }
   
}
